(function () {
  'use strict';

  var busy = false;

  function rootPath() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function commerceForm(element) {
    return element && element.closest('.rc-flow__product-form, .rc-flow__sticky-form');
  }

  function selectedVariant(form) {
    var input = form && form.querySelector('[name="id"]');
    return input ? input.value : '';
  }

  function selectedQuantity(form) {
    var input = form && form.querySelector('[name="quantity"]');
    var quantity = input ? parseInt(input.value, 10) : 1;
    return quantity >= 1 && quantity <= 3 ? quantity : 1;
  }

  function setBusy(form, action, state) {
    form.setAttribute('aria-busy', state ? 'true' : 'false');
    form.querySelectorAll('[data-rc-add-to-cart], [data-rc-buy-now]').forEach(function (button) {
      if (state) {
        button.dataset.rcOriginal = button.innerHTML;
        button.disabled = true;
        button.classList.add('is-loading');
        button.textContent = action === 'checkout' ? 'Opening checkout…' : 'Adding…';
      } else {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (button.dataset.rcOriginal) button.innerHTML = button.dataset.rcOriginal;
      }
    });
  }

  function showError(form, message) {
    var box = form.querySelector('[data-rc-commerce-error]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'rc-flow__commerce-error';
      box.setAttribute('data-rc-commerce-error', '');
      box.setAttribute('role', 'alert');
      form.appendChild(box);
    }
    box.textContent = message || 'We couldn’t add that item. Please try again.';
  }

  function add(form, destination) {
    if (busy) return;
    var variantId = selectedVariant(form);
    if (!variantId) {
      showError(form, 'Please choose a color first.');
      return;
    }

    busy = true;
    var action = destination === 'checkout' ? 'checkout' : 'cart';
    setBusy(form, action, true);

    var data = new FormData();
    data.set('id', variantId);
    data.set('quantity', String(selectedQuantity(form)));

    fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: data,
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          if (!response.ok) throw new Error(payload.description || payload.message || 'This item could not be added.');
          return payload;
        });
      })
      .then(function () {
        window.location.assign(rootPath() + (destination === 'checkout' ? 'checkout' : 'cart'));
      })
      .catch(function (error) {
        busy = false;
        setBusy(form, action, false);
        showError(form, error.message);
      });
  }

  document.addEventListener('submit', function (event) {
    var form = commerceForm(event.target);
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    add(form, 'cart');
  }, true);

  document.addEventListener('click', function (event) {
    var buyNow = event.target.closest('[data-rc-buy-now]');
    if (!buyNow) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var form = commerceForm(buyNow);
    if (form) add(form, 'checkout');
  }, true);

  window.addEventListener('pageshow', function () {
    busy = false;
    document.querySelectorAll('.rc-flow__product-form, .rc-flow__sticky-form').forEach(function (form) {
      setBusy(form, 'cart', false);
    });
  });
})();